import getGeneralTab from './getGeneralTab';
import getReviewsTab from './getReviewsTab';
import getEnvironmentTab from './getEnvironmentTab';
import getMarketTab from './getMarketTab';
import getRentalsTab from './getRentalsTab';
import generateAnalyticsCsv from './generateAnalyticsCsv';
import saveUserExportSuperbudgetData from './saveUserExportSuperbudgetData';
import getAnalyseResults from './getAnalyseResults';
import getExtractorResults from './getExtractorResults';
import generateConciergeData from './generateConciergeData';

export default {
  getGeneralTab,
  getReviewsTab,
  getEnvironmentTab,
  getMarketTab,
  getRentalsTab,
  generateAnalyticsCsv,
  saveUserExportSuperbudgetData,
  getAnalyseResults,
  getExtractorResults,
  generateConciergeData,
};



// WEBPACK FOOTER //
// ./src/app/services/analytics/index.js